import { PaginationRequest } from "../../../models/Request/apiDateFormatRequest";
import { InboxMessageResponse } from "../models/response/InboxMessageResponse";
import { inboxApi } from "../api/inbox.api";
import errorModal from "../../../services/errorModal.service";

export async function getInboxMessages(
    request: PaginationRequest
): Promise<InboxMessageResponse | null> {
    var response = await inboxApi.getInboxMessages(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.data;
}

export async function readInboxMessage(request: {
    id: string;
}): Promise<boolean> {
    var response = await inboxApi.readInboxMessage(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.isSuccess;
}

export async function deleteInboxMessage(request: {
    id: string;
}): Promise<boolean> {
    var response = await inboxApi.deleteInboxMessage(request);

    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.isSuccess;
}

export async function readAllInboxMessages(request: {
    isAllRead: boolean;
}): Promise<boolean> {
    var response = await inboxApi.readAllInboxMessages(request);
    if (!response.isSuccess) {
        errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response.isSuccess;
}